import type { AxiosResponse } from "axios"

import { apiClient } from "../../lib/axios"
import { getHostnames } from "../../utils/genericHelpers"

const { llm } = getHostnames()

export const KonanAssistantApi = {
  createSession: async (props: {
    projectId: string
    agent_type: "COMPONENT_CREATION_AGENT" | "CHAT_DATA_AGENT"
  }): Promise<AxiosResponse> => {
    const { projectId, agent_type } = props
    return apiClient.postResource(llm, "/chat-sessions/", { project_uuid: projectId, agent_type })
  },
  listSessions: async (props: { projectId: string }): Promise<AxiosResponse> => {
    const { projectId } = props
    return apiClient.fetchResource(llm, "/chat-sessions/", { project_uuid: projectId })
  },
  addMessageToSession: async (props: { sessionId: string; question: string }): Promise<AxiosResponse> => {
    const { sessionId, question } = props
    return apiClient.postResource(llm, `/chat-sessions/${sessionId}/messages`, { question })
  },
  retrieveSessionMessages: async (props: { sessionId: string }): Promise<AxiosResponse> => {
    const { sessionId } = props
    return apiClient.fetchResource(llm, `/chat-sessions/${sessionId}/messages`)
  },
}
